export const queryKeys = {
    requisitions: 'requisitions',
    candidate: 'candidate',
    client: 'client',
    VSAT: 'VSAT',
    apprenticeship: 'apprenticeship',
}